import { Dimensions, StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

const windowWidth = Dimensions.get('window').width;
const screenWidth = Dimensions.get('screen').width;
const loadingContainerMarginHorizontal = 21;
const tabContainerMarginRight = 16;
const widthMinusMargins =
  screenWidth - loadingContainerMarginHorizontal * 2 - tabContainerMarginRight;

export default StyleSheet.create({
  lineStyle: {
    width: 165,
    height: 12,
  },
  tabContainerStyle: theme => ({
    width: widthMinusMargins / 2,
    height: 50,
    borderRadius: 6,
    marginTop: 21,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: theme.colors.shimmerBorder,
    backgroundColor: Colors.snow,
    marginRight: tabContainerMarginRight,
    paddingHorizontal: 45,
    paddingVertical: 18,
    marginBottom: 45,
  }),
  tabContentStyle: theme => ({
    width: 65,
    height: 12,
    backgroundColor: theme.colors.shimmerBorder,
  }),
  optionContainerStyle: theme => ({
    width: widthMinusMargins / 3,
    height: 70,
    borderRadius: 6,
    marginTop: 21,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: theme.colors.shimmerBorder,
    backgroundColor: Colors.snow,
    marginRight: 8,
    paddingTop: 7,
  }),
  optionContentStyle: (width, theme) => ({
    width: width,
    height: 12,
    marginBottom: 8,
    alignSelf: 'center',
    backgroundColor: theme.colors.shimmerBorder,
  }),
  footerSecondSectionStyle: theme => ({
    marginTop: 23,
    marginBottom: 16,
    borderWidth: 2,
    borderRadius: 6,
    borderColor: theme.colors.shimmerBorder,
    paddingLeft: 16,
    paddingRight: 21,
    paddingVertical: 17,
  }),
  footerSecondSectionSquareStyle: {
    width: 48,
    height: 32,
    marginRight: 19,
  },
  footerSecondSectionMainFirstLineStyle: {
    height: 12,
    marginBottom: 9,
  },
  footerSecondSectionMainSecondLineStyle: {
    height: 12,
  },
  footerSecondSectionRightLineStyle: {
    width: 52,
    height: 12,
    marginTop: 20.5,
  },
  footerFirstSectionLeftLineStyle: {
    height: 12,
    width: (windowWidth - 50) / 2 - 16 + 25,
  },
  footerFirstSectionStyle: {
    marginTop: 44,
  },
  footerFirstSectionRightLineStyle: {
    height: 12,
    width: 52,
  },
  divider: {
    height: 1,
    marginTop: 10,
    marginBottom: 29,
  },
  bottomLineStyle: {
    height: 12,
    marginBottom: 8,
  },
  footerThirdSectionSquareStyle: {
    width: windowWidth - 32,
    height: 27,
    marginTop: 26,
  },
  rowContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  loadingContainerStyle: {
    marginHorizontal: loadingContainerMarginHorizontal,
    marginTop: 29,
  },
});
